function normalizeSourceLabel(value: string | null | undefined) {
  const normalized = value?.trim().replace(/\s+/g, " ").toLowerCase();
  return normalized ? normalized : null;
}

function normalizeOffTag(value: string | null | undefined) {
  const normalized = value?.trim().toLowerCase();
  return normalized ? normalized : null;
}

export function normalizeOffCategorySourceId(tag: string | null | undefined) {
  const normalized = normalizeOffTag(tag);
  return normalized ? `off:category:${normalized}` : null;
}

export function normalizeUsdaSurveyCategorySourceId(description: string | null | undefined) {
  const normalized = normalizeSourceLabel(description);
  return normalized ? `usda-survey:wweia-family:${normalized}` : null;
}

export function normalizeUsdaSrFoundationCategorySourceId(description: string | null | undefined) {
  const normalized = normalizeSourceLabel(description);
  return normalized ? `usda-sr-foundation:food-category:${normalized}` : null;
}

export function normalizeUsdaBrandedCategorySourceId(description: string | null | undefined) {
  const normalized = normalizeSourceLabel(description);
  return normalized ? `usda-branded:retail-family:${normalized}` : null;
}

export function normalizedSourceIdMap(
  values: readonly string[],
  normalize: (value: string) => string | null,
) {
  const sourceIds: string[] = [];
  const sourceLabelById = new Map<string, string>();

  for (const value of values) {
    const sourceId = normalize(value);
    if (!sourceId) {
      continue;
    }

    sourceIds.push(sourceId);
    if (!sourceLabelById.has(sourceId)) {
      sourceLabelById.set(sourceId, value.trim());
    }
  }

  return { sourceIds, sourceLabelById };
}
